/* Third party component for comment section in overview tab */

import {
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBInput,
  MDBRow,
} from "mdb-react-ui-kit";

import { MessageSquare, Send, Minus } from "lucide-react";
import { useState } from "react";
import { ProfileImg } from "./ProfileIMG";
import { formatNoteTimestamp } from "../utils";

export default function NotesBoard(props){
    const [newNote, setNewNote] = useState("");

    function noteCB(note){
        return (
            <MDBCard className="mb-3" key={note.noteId}>
                <MDBCardBody className="bg-amber-50 rounded-lg p-4 !border border-amber-100">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between w-full mb-2 gap-2">
                        <div className="flex items-start gap-3">
                            <ProfileImg svgString={note.profileImg} className="rounded-4xl w-7 h-7 sm:w-8 sm:h-8" />
                            <span className="text-amber-900">{note.authorName}</span>
                        </div>
                        <span className="float-right text-amber-600">
                          {formatNoteTimestamp(note.timestamp)}

                        </span>
                    </div>
                    <div>
                        <p className="text-amber-800 whitespace-pre-wrap">{note.message}</p>
                    </div>
                    {props.currentUser.userId === note.authorId && (
                      <button 
                      onClick={()=> handleRemoveACB(props.clubId,note.noteId)}
                      className="flex absolute top-[60%] right-2 -translate-y-1/2 items-center gap-1 px-1 py-1 !rounded-lg border-1 border-red-300 bg-red-200"
                    >
                      <Minus className="w-5 h-5 text-red-500" />
                      <span className="text-xs text-red-800 !font-light">Remove</span>
                    </button>

                    )}
                    
                </MDBCardBody>
            </MDBCard>
        )
    }

    function handleSubmitACB(){
        //console.log(props.currentUser.name);
        //console.log(props.currentUser);
        //console.log(props.clubId);
        props.onAddNote(props.clubId, props.currentUser.userId, props.currentUser.name, props.currentUser.profileImg, newNote);
        setNewNote("");
    }

    function handleRemoveACB(clubId, noteId){
      props.onRemoveNote(clubId,noteId);
    }

    return <MDBContainer fluid className="mt-5">
        <MDBRow className="justify-content-center">
                <div className="bg-white rounded-xl p-6 !border border-amber-200">
                    <div className="flex items-center gap-2 mb-4">
                        <MessageSquare className="w-5 h-5 text-amber-600 relative -translate-y-1" />
                        <h3 className="text-amber-900">Notes Board</h3>
                    </div>

                    {/* Create and post new note */}
                    <div className="mb-4">
                        {/* Text box */}
                        <textarea 
                          value={newNote}
                          onChange={(evt) => setNewNote(evt.target.value)}
                          placeholder="Share your thoughts!"
                          className="w-full px-4 py-3 !border border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 resize-none"
                          rows={3}/>
                            
                        {/* Submit button */}
                        <button 
                          onClick={handleSubmitACB}
                          disabled={!newNote.trim()}
                          className={`mt-2 px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-600 text-white !rounded-lg hover:from-amber-600 hover:to-orange-700 transition-all flex items-center gap-2
                            ${!newNote.trim() ? "opacity-50 cursor-not-allowed" : ""}`}
                        >
                          <Send className="w-4 h-4" />
                          <span>Post Note</span>
                        </button>
                    </div>
                    <div>{[...(props.notes ?? [])].sort((a, b) => b.timestamp - a.timestamp).map(noteCB)}</div>
                </div>
        </MDBRow>
    </MDBContainer>;
}

//the original component that has been modified to NotesBoard
export function CommentBoard(props) {
  return (
    <MDBContainer className="mt-5" style={{ maxWidth: "1000px" }}>
      <MDBRow className="justify-content-center">
        <MDBCol md="8" lg="6">
          <MDBCard
            className="shadow-0 border"
            style={{ backgroundColor: "#f0f2f5" }}
          >
            <MDBCardBody>
              <MDBInput wrapperClass="mb-4" placeholder="Type comment..." label="+ Add a note" />

              <MDBCard className="mb-4">
                <MDBCardBody>
                  <p>Type your note, and hit enter to add it</p>

                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                      <MDBCardImage
                        src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(4).webp"
                        alt="avatar"
                        width="25"
                        height="25"
                      />
                      <p className="small mb-0 ms-2">Martha</p>
                    </div>
                    <div className="d-flex flex-row align-items-center">
                      <p className="small text-muted mb-0">Upvote?</p>
                      <MDBIcon
                        far
                        icon="thumbs-up mx-2 fa-xs text-black"
                        style={{ marginTop: "-0.16rem" }}
                      />
                      <p className="small text-muted mb-0">3</p>
                    </div>
                  </div>
                </MDBCardBody>
              </MDBCard>

              <MDBCard className="mb-4">
                <MDBCardBody>
                  <p>Type your note, and hit enter to add it</p>

                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                      <MDBCardImage
                        src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(32).webp"
                        alt="avatar"
                        width="25"
                        height="25"
                      />
                      <p className="small mb-0 ms-2">Johny</p>
                    </div>
                    <div className="d-flex flex-row align-items-center">
                      <p className="small text-muted mb-0">Upvote?</p>
                      <MDBIcon
                        far
                        icon="thumbs-up mx-2 fa-xs text-black"
                        style={{ marginTop: "-0.16rem" }}
                      />
                      <p className="small text-muted mb-0">4</p>
                    </div>
                  </div>
                </MDBCardBody>
              </MDBCard>

              <MDBCard className="mb-4">
                <MDBCardBody>
                  <p>Type your note, and hit enter to add it</p>

                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                      <MDBCardImage
                        src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(31).webp"
                        alt="avatar"
                        width="25"
                        height="25"
                      />
                      <p className="small mb-0 ms-2">Mary Kate</p>
                    </div>
                    <div className="d-flex flex-row align-items-center text-primary">
                      <p className="small mb-0">Upvoted</p>
                      <MDBIcon
                        fas
                        icon="thumbs-up mx-2 fa-xs"
                        style={{ marginTop: "-0.16rem" }}
                      />
                      <p className="small mb-0">2</p>
                    </div>
                  </div>
                </MDBCardBody>
              </MDBCard>

              <MDBCard className="mb-4">
                <MDBCardBody>
                  <p>Type your note, and hit enter to add it</p>

                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                      <MDBCardImage
                        src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(32).webp"
                        alt="avatar"
                        width="25"
                        height="25"
                      />
                      <p className="small mb-0 ms-2">Johny</p>
                    </div>
                    <div className="d-flex flex-row align-items-center">
                      <p className="small text-muted mb-0">Upvote?</p>
                      <MDBIcon
                        far
                        icon="thumbs-up mx-2 fa-xs text-black"
                        style={{ marginTop: "-0.16rem" }}
                      />
                      <p className="small text-muted mb-0"></p>
                    </div>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}